var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"pic"},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.productItem.Content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }